import confetti from "canvas-confetti";

// Fired when a card lands in the client's conversion column. Deliberately small
// and self-contained: it is called from `useMoveCard`'s `onSuccess`, never from the
// optimistic `onMutate` — celebrating a move that then rolls back reads worse than
// not celebrating at all.
export function celebrateConversion(): void {
  // A confetti burst is pure decoration, and for someone who asked the OS not to
  // animate it is an accessibility problem. The toast still fires either way.
  if (
    typeof window !== "undefined" &&
    window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
  ) {
    return;
  }

  // Two offset bursts rather than one centered puff — it reads as a celebration
  // instead of a loading state. `moss`/`lime` are the brand greens.
  const shared = { particleCount: 60, spread: 70, startVelocity: 45, ticks: 140 };
  const colors = ["#617E00", "#A3C900", "#0E0D0A"];
  void confetti({ ...shared, origin: { x: 0.3, y: 0.7 }, angle: 60, colors });
  void confetti({ ...shared, origin: { x: 0.7, y: 0.7 }, angle: 120, colors });
}
